class TurnstileService {
    private configCache: { siteKey: string; enabled: boolean } | null = null;
    private configPromise: ng.IPromise<{ siteKey: string; enabled: boolean }> | null = null;
    private scriptLoaded: boolean = false;
    private scriptLoadPromise: ng.IPromise<void> | null = null;

    static $inject = ['$http', '$q', '$document', 'apiRoutes'];
    constructor(
        private $http: ng.IHttpService,
        private $q: ng.IQService,
        private $document: ng.IDocumentService,
        private apiRoutes: any
    ) {}

    getConfig(): ng.IPromise<{ siteKey: string; enabled: boolean }> {
        if (this.configCache) {
            return this.$q.resolve(this.configCache);
        }

        if (this.configPromise) {
            return this.configPromise;
        }

        this.configPromise = this.$http.get<{ siteKey: string; enabled: boolean }>(
            `${this.apiRoutes.registration}registration/turnstile-config`
        ).then((response) => {
            this.configCache = response.data;
            return response.data;
        });

        return this.configPromise;
    }

    loadScript(): ng.IPromise<void> {
        if (this.scriptLoaded && (window as any).turnstile) {
            return this.$q.resolve();
        }

        if (this.scriptLoadPromise) {
            return this.scriptLoadPromise;
        }

        var deferred = this.$q.defer<void>();
        this.scriptLoadPromise = deferred.promise;

        (window as any).onTurnstileLoad = () => {
            this.scriptLoaded = true;
            deferred.resolve();
        };

        var doc = this.$document[0] as Document;
        if (doc.getElementById('turnstile-script')) {
            if ((window as any).turnstile) {
                this.scriptLoaded = true;
                deferred.resolve();
            }
            return this.scriptLoadPromise;
        }

        var script = doc.createElement('script');
        script.id = 'turnstile-script';
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onTurnstileLoad';
        script.async = true;
        script.defer = true;
        doc.head.appendChild(script);

        return this.scriptLoadPromise;
    }

    renderWidget(
        containerId: string,
        siteKey: string,
        callbacks: {
            onVerified: (token: string) => void;
            onError: () => void;
            onExpired: () => void;
        }
    ): string | null {
        if (!(window as any).turnstile) {
            return null;
        }

        var container = (this.$document[0] as Document).getElementById(containerId);
        if (!container) {
            return null;
        }

        try {
            return (window as any).turnstile.render(container, {
                sitekey: siteKey,
                theme: 'light',
                size: 'normal',
                callback: callbacks.onVerified,
                'error-callback': callbacks.onError,
                'expired-callback': callbacks.onExpired
            });
        } catch (e) {
            return null;
        }
    }

    resetWidget(widgetId: string): void {
        if (widgetId && (window as any).turnstile) {
            try { (window as any).turnstile.reset(widgetId); } catch (e) { }
        }
    }

    getResponse(widgetId: string): string {
        if (widgetId && (window as any).turnstile) {
            return (window as any).turnstile.getResponse(widgetId) || '';
        }
        return '';
    }

    removeWidget(widgetId: string): void {
        if (widgetId && (window as any).turnstile) {
            try { (window as any).turnstile.remove(widgetId); } catch (e) { }
        }
    }
}

angular
    .module('app')
    .service('TurnstileService', TurnstileService);
